<template>
  <div class="info">
    <img :src="imageSource(devicein.deviceType)" class="deviceimg" alt="..." />
    <div class="verticalline"></div>
    <div class="infocontent">
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceName") }}</div>
        <div class="infonumber" :title="devicein.orderNumber">
          {{ devicein.orderNumber }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceType") }}</div>
        <div class="infonumber" :title="deviceType(devicein.deviceType)">
          {{ deviceType(devicein.deviceType) }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceStatus") }}</div>
        <div class="infonumber" :title="deviceState(devicein.state)">
          <span :style="{ color: stateColor() }">{{ deviceState(devicein.state) }}</span>
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.deviceTask") }}</div>
        <div class="infonumber" :title="devicein.task">
          {{ devicein.task }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const { t } = useI18n();

const props = defineProps({
  devicein: { type: Object, required: true },
});

let state = ref(props.devicein.state);

onMounted(() => {});

const stateColor = () => {
  return state.value == "0"
    ? "#009431"
    : state.value == "1"
    ? "#e0bb00"
    : state.value == "2"
    ? "#0064c8"
    : "#e00000";
};

function imageSource(type) {
  return type == "sheet"
    ? require("@/assets/img/device/C.png")
    : require("@/assets/img/device/Q.png");
}

function deviceType(type) {
  return type == "sheet" ? t("index.sheet") : t("index.tube");
}

function deviceState(state) {
  return state == "0"
    ? t("index.run")
    : state == "1"
    ? t("index.idle")
    : state == "2"
    ? t("index.offline")
    : t("index.stop");
}
</script>

<style scoped>
.info {
  display: flex;
  justify-content: space-between;
}
.deviceimg {
  height: 200px;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.infocontent {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
  margin-right: 10px;
}
.infoitemsMin {
  width: 100% !important;
  margin-top: 10px !important;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
